import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "js-main-content" }
const _hoisted_2 = { class: "gfu-homepage-wrapper _grid _grid-cols-1 _grid-cols-24--l _grid-cols-24--xl _row-gap-6" }
const _hoisted_3 = { class: "_col-span-1 _col-span-5--l _col-span-4--xl _flexcol _ai-st _order-7 _order-1--l" }
const _hoisted_4 = {
  key: 0,
  role: "region",
  "aria-labelledby": "home-project-lists-title",
  class: "_flexcol _grow-1"
}
const _hoisted_5 = {
  class: "_col-span-1 _col-span-13--l _col-span-15--xl gfu-homepage-featured-projects _order-1 _order-2--l",
  role: "region",
  "data-qa": "homepage-section:Featured"
}
const _hoisted_6 = {
  class: "_col-span-1 _col-span-6--l _col-span-5--xl _flexcol _ai-st _order-2 _order-3--l",
  role: "region",
  "aria-labelledby": "home-spotlight-title",
  "data-qa": "homepage-section:Spotlight"
}
const _hoisted_7 = {
  key: 0,
  class: "_col-span-1 _col-span-24--l _order-3 _order-4--l",
  role: "region"
}
const _hoisted_8 = {
  key: 1,
  class: "_col-span-1 _col-span-24--l _order-4 _order-5--l",
  role: "region",
  "aria-labelledby": "home-rankings-title",
  "data-qa": "homepage-section:Rankings"
}
const _hoisted_9 = {
  class: "_col-span-1 _col-span-24--l _order-5 _order-6--l",
  role: "region",
  "data-qa": "homepage-section:Explore"
}
const _hoisted_10 = {
  class: "_col-span-1 _col-span-24--l _order-8",
  role: "region"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_home_hero_banner = _resolveComponent("home-hero-banner")
  const _component_home_section_title = _resolveComponent("home-section-title")
  const _component_home_project_list = _resolveComponent("home-project-list")
  const _component_featured_projects = _resolveComponent("featured-projects")
  const _component_spotlight = _resolveComponent("spotlight")
  const _component_announcements = _resolveComponent("announcements")
  const _component_projects_ranking = _resolveComponent("projects-ranking")
  const _component_explore_projects_section = _resolveComponent("explore-projects-section")
  const _component_home_platform_statistics = _resolveComponent("home-platform-statistics")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    ($options.isHeroBannerEnabled)
      ? (_openBlock(), _createBlock(_component_home_hero_banner, { key: 0 }))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!$options.isLaunchCampaignBoxEnabled)
          ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
              _createVNode(_component_home_section_title, {
                id: "home-project-lists-title",
                class: "_mb-3",
                "icon-name": "grid-horizontal"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.Homepage.ProjectListsSectionTitle), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_home_project_list)
            ]))
          : (_openBlock(), _createBlock(_component_home_project_list, { key: 1 }))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_featured_projects)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_home_section_title, {
          id: "home-spotlight-title",
          class: "_mb-3",
          "icon-name": "lighthouse"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.Resources.Homepage.SpotlightSectionTitle), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_spotlight)
      ]),
      ($props.hasBanner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_announcements, {
              "preview-banner-id": $props.previewBannerId,
              "data-qa": "home-page-box:InfoBanners"
            }, null, 8 /* PROPS */, ["preview-banner-id"])
          ]))
        : _createCommentVNode("v-if", true),
      ($options.isRankingEnabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_projects_ranking, { "default-category": $options.rankingsDefaultCategory }, {
              title: _withCtx(() => [
                _createVNode(_component_home_section_title, {
                  id: "home-rankings-title",
                  "icon-name": "trophy"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Resources.Homepage.RankingsSectionTitle), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["default-category"])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_explore_projects_section)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_home_platform_statistics)
      ])
    ])
  ]))
}